module.exports = __webpack_public_path__ + "img/image-header-phone.25eae7d5.png";